// VanJS Feather - Download
import van from "vanjs-core";
import { FeatherIcon, svgNamespace } from "../FeatherIcon.ts";
import { type SVGProps } from "../types.ts";

export const Download = (props: Partial<SVGProps> = {}) => {
  const { path, polyline, line } = van.tags(svgNamespace);

  return FeatherIcon(
    props,
    path({ "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
    polyline({ points: "7 10 12 15 17 10" }),
    line({
      x1: "12",
      y1: "15",
      x2: "12",
      y2: "3",
    }),
  );
};
